import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo as defaultCompanyInfo } from '../data/mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/content`);
        setContent(response.data);
      } catch (error) {
        console.error('Error fetching content:', error);
      }
    };
    fetchContent();
  }, []);

  const companyInfo = {
    logo: content?.logo_url || defaultCompanyInfo.logo,
    phone: content?.phone || defaultCompanyInfo.phone,
    email: content?.email || defaultCompanyInfo.email,
    address: content?.address || defaultCompanyInfo.address,
    workingHours: content?.working_hours || defaultCompanyInfo.workingHours
  };

  return (
    <footer className="bg-navy-dark border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt="United ELD LLC" 
              className="h-28 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              Electronic Logging Solutions for trucking companies and owner-operators.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-white/60 hover:text-red-500 transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-white/60 hover:text-red-500 transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-3 text-white/60 hover:text-red-500 transition-colors text-sm"
                >
                  <Phone className="h-4 w-4 flex-shrink-0" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-white/60 hover:text-red-500 transition-colors text-sm"
                >
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-white/60 text-sm">
                  <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                  {companyInfo.address}
                </div>
              </li>
              <li>
                <div className="flex items-center gap-3 text-white/60 text-sm">
                  <Clock className="h-4 w-4 flex-shrink-0" />
                  {companyInfo.workingHours}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <p className="text-center text-white/40 text-sm">
            © {new Date().getFullYear()} United ELD LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
